var _ = require('lodash');
var angular = require('angular/index');
require('../core');

angular.module('utility-ng-interface').run(function (Interface, $injector) {
  Interface.type('ngEnum', _.clone(Interface.type('enum')));
  Interface.type('ngOrdinal', _.clone(Interface.type('ordinal')));

  Interface.type('ngEnum').convertToSync = function (sourceValue, requirement) {
    requirement.typeDef = !!requirement.typeDef.isEnumType ? requirement.typeDef : $injector.get(requirement.typeDef);

    return Interface.type('enum').convertToSync(sourceValue, requirement);
  };

  Interface.type('ngOrdinal').convertToSync = function (sourceValue, requirement) {
    requirement.typeDef = !!requirement.typeDef.isEnumType ? requirement.typeDef : $injector.get(requirement.typeDef);

    return Interface.type('ordinal').convertToSync(sourceValue, requirement);
  };
});



// WEBPACK FOOTER //
// ./app/vendor/utility-ng-interface/src/types/types.js